"use client";

import styled from "styled-components";

//Component
import { ChartContainer } from "../ui/chart";

export const BoxContainerChart = styled(ChartContainer)`
  width: 100%;
  max-height: 320px;
  height: 100%;
`;
